<template>
  <div class="cmp-home ut-fh">
    <div class="ut-fc ut-fh ut-colcen">
      <div style="width: 680px; margin-top: -73px !important">
        <h2 class="overview">
          {{$t('welcome')}} {{ $store.getters.account.user.staff_fullname }}!
        </h2>
        <p class="subtitle">{{$t('welcome_start')}}</p>
        <div class="module-grid">
          <div
            v-for="mod of modules"
            class="module-item"
            :class="{
              disabled: mod.disabled,
            }"
            :key="mod.route"
            style="width: 104px"
          >
            <router-link
              :to="{ path: `/main/${mod.route}/${defaultChild(mod).route}` }"
            >
              <div class="module-image">
                <img
                  :src="moduleImage(mod.img)"
                  alt=""
                  style="width: 56px; height: 56px"
                />
              </div>
              <div class="module-title">{{ $dft.capHead($t(mod.tkey)) }}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log("Home Mounted");
    console.log(this.$router);
  },
  computed: {
    modules: function () {
      console.log("this.$store", this.$store.state);
      const getterItems = this.$store?.getters?.appNavItems;
      const items = [...(this.$store?.state?.app?.appNavItems || [])].map(
        (item) => {
          if (!getterItems.find((i) => i.route === item.route)) {
            return {
              ...item,
              disabled: true,
            };
          }
          return item;
        }
      );
      // If any item exists on state but not on getterItems then assign disabled to true for that item
      // items.forEach((item) => {
      //   if (!getterItems.find((i) => i.route === item.route)) {
      //     item.disabled = true;
      //   }
      // });

      // If Promotion Does not exist then add it
      // if (!items.find((i) => i.route === "promotion")) {
      //   items.splice(6, 0, {
      //     title: "Promotion",
      //     route: "promotion",
      //     tkey: "promotion",
      //     img: "static/icons/nav/promotion.svg",
      //     disabled: true,
      //     children: [
      //       {
      //         icon: "video_label",
      //         title: "Promotion Contacts",
      //         route: "promotion_contacts",
      //       },
      //       {
      //         icon: "video_label",
      //         title: "Mailing Lists",
      //         route: "mailing_lists",
      //       },
      //       { icon: "video_label", title: "Campaigns", route: "campaigns" },
      //       { icon: "video_label", title: "Results", route: "results" },
      //       { icon: "video_label", title: "Marketing", route: "marketing" },
      //       { icon: "video_label", title: "Plugins", route: "plugins" },
      //     ],
      //   });
      // }
      // If Management Does not exist then add it
      // if (!items.find((i) => i.route === "management")) {
      //   items.splice(7, 0, {
      //     title: "Management",
      //     route: "management",
      //     tkey: "management",
      //     img: "static/icons/nav/management.svg",
      //     disabled: true,
      //     children: [
      //       { icon: "video_label", title: "Artists", route: "artists" },
      //       { icon: "video_label", title: "Projects", route: "projects" },
      //       { icon: "video_label", title: "Plugins", route: "plugins" },
      //     ],
      //   });
      // }
      return items;
    },
  },
  methods: {
    onModuleItemClick(mod) {
      this.$router.push({
        name: mod.route,
      });
    },
    defaultChild(mod) {
      return mod?.children?.find((c) => c.default === true) || { route: "" };
    },
    moduleImage(src) {
      // Replace the nav with welcome in string
      const newSrc = src.replace("nav", "welcome");
      return newSrc;
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-home {
  .overview {
    color: var(--text-primary);
    // font-weight: bold;
    font-size: 22px;
    margin-bottom: 5px;
  }
  .subtitle {
    font-size: 15px;
    margin-bottom: 40px;
  }
  .module-grid {
    display: grid;
    gap: 40px;
    grid-template-columns: repeat(4, minmax(104px, 1fr));
    .module-item {
      cursor: pointer;
      transition: transform 0.2s ease-out;
      &:hover {
        // transform: scale(1.05);
      }
      &.disabled {
        opacity: 0.5;
      }
      .module-image {
        // transition: all 0.2s ease-out;
        background: var(--bc-3);
        border-radius: 16px;
        width: 104px;
        height: 104px;
        border: 2px solid rgba(0, 0, 0, 0.005);

        display: flex;
        justify-content: center;
        align-items: center;
      }
      &:hover:not(.disabled) {
        .module-image {
          border: 2px solid var(--bc-accent5);
          background: var(--bc-cblue);
        }
        // box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
      }
      &:active {
        .module-image {
          background: var(--bc-cblue2);
        }
        // box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
      }
      .module-title {
        height: 24px;
        color: var(--text-primary);
        // text-align: center;
        align-items: center;
        display: flex;
        justify-content: center;
        text-transform: uppercase;
      }
    }
  }
}
</style>